import alt from 'components/Dispatcher';

class CoachingPlaylistActions {
  constructor() {
    this.generateActions(
      'show',
      'hide',
      'minimize',
      'toggle',
      'triggerFlash',
      'openWithFlash',
      'flashedOnOpen',
      'setAddCallsMode',
      'setCanAddCalls',
      'setCurrentlyViewing',
      'reset'
    );
  }
}

export default alt.createActions(CoachingPlaylistActions);
